/* eslint-disable no-shadow */
/* eslint-disable default-param-last */
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import Catalyst from '@Services/Catalyst';
import Breadcrumb from '@Services/Breadcrumb';
import compact from 'lodash/compact';
import extend from 'lodash/extend';
import pick from 'lodash/pick';
import reject from 'lodash/reject';
import isUndefined from 'lodash/isUndefined';
import { getCombinedRouteParams, getTrackingPathName } from '@AppRoutes/AppRoutesSelectors';
import store from '@Store';

const ROUTES_NAMES = {
  'main.search.quick.results': 'query:preview',
  'public.login': 'sign-in',
  default: 'results',
};
export const formActionName = (action, context, skipPrefix = false) => {
  const activeBreadCrumb = Breadcrumb.getActiveBreadcrumbForDb(getCombinedRouteParams(store.getState()).databaseId);
  const trackingPathName = getTrackingPathName(store.getState());
  const substanceGridView = getValueByNs(activeBreadCrumb, 'substanceGridView');
  const sections = [
    !skipPrefix ? Catalyst.getPrefix() : null,
    ROUTES_NAMES[trackingPathName] || ROUTES_NAMES.default,
    substanceGridView && context === 'substances' ? 'substancesgrid' : context,
    action,
  ];
  return compact(sections).join(':');
};

export const structureContentInteraction = (action, context = getCombinedRouteParams(store.getState()).context, content) => {
  const name = formActionName(action, context, true);
  Catalyst.trackContentInteraction(name, content);
};

export const trackContentLinkClick = (title, location) => {
  Catalyst.trackContentLinkClick(title, undefined, undefined, location);
};

export const productFeatureUsed = (action, context = getCombinedRouteParams(store.getState()).context) => {
  const name = formActionName(action, context);
  Catalyst.trackProductFeature(name);
};

export const formContent = (data, content) => {
  return extend(
    pick(data, [
      'authorNames',
      'docLink',
      'title',
      'publicationType',
      'onlineDate',
      'publicationDate',
      'indexTerms',
      'issueNumber',
      'volumeNumber',
    ]),
    content
  );
};

export const formType = (event, preview, context, location, action) => {
  const parts = reject([Catalyst.getPrefix(), event, preview ? 'previewresult' : 'results', context], isUndefined);
  if (location) {
    parts.push(location);
  }
  parts.push(action);
  return parts.join(':');
};

export const contentView = (context, data, preview, location, action, extended) => {
  const content = formContent(data, {
    id: `cit:${data.id}`,
    type: formType('contentview', preview, context, location, action),
  });
  Catalyst.trackContentView('contentView', content, extended);
};

export const linkOut = (context, data, linkUrl, preview, location, action, extended) => {
  const content = formContent(data, {
    id: `linkout:${data.id}`,
    linkOut: data.citationName,
    type: formType('linkout', preview, context, location, action),
  });

  const link = {
    location: linkUrl,
    name: data.citationName,
    type: data.citationType,
    ...(extended && extended.link),
  };

  Catalyst.trackLinkOut(content, link, extended);
};
